import { type ngToast } from '@Types';
import { angularInjectorProvider } from 'Injector';

// Shows a global toast through the Angular ngToast service. The original modal used ngToast for save
// and upload feedback. This keeps that behavior in the React port. The function does nothing when the
// service is absent, for example in a unit test.
export function notifyToast(content: string, className: 'success' | 'danger' | 'warning' | 'info' = 'success') {
    const ngToast = angularInjectorProvider.safeGet<ngToast>('ngToast');
    if (!ngToast) return;
    ngToast.create({ content, className });
    // A React handler or a save promise calls this from outside Angular's digest. The ngToast
    // ngRepeat does not flush on its own there, so the toast never renders. Schedule a digest.
    angularInjectorProvider.safeGet<{ $applyAsync: () => void }>('$rootScope')?.$applyAsync();
}
